import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {BacnetDataPoint} from "../../../../domain/device.interface";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {BacnetDeviceNameDescription} from "../../../../domain/bacnet-device";

@Component({
  selector: 'eis-gateway-bacnet-preview-undeployed-device-table',
  templateUrl: './bacnet-preview-undeployed-device-table.component.html',
  styleUrls: ['./bacnet-preview-undeployed-device-table.component.scss']
})
export class BacnetPreviewUndeployedDeviceTableComponent implements  AfterViewInit, OnChanges {

  public displayedColumns: string[] = ['deviceName','deviceId', 'description']

  @Input()
  devices: BacnetDeviceNameDescription[] = [];

  @ViewChild(MatSort) sort: MatSort;

  deviceNameDescriptionMatTableDataSource:MatTableDataSource<BacnetDeviceNameDescription> = new MatTableDataSource<BacnetDeviceNameDescription>();

  constructor() {
  }



  ngAfterViewInit(): void {
    this.deviceNameDescriptionMatTableDataSource.sort=this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['devices']) {
      this.deviceNameDescriptionMatTableDataSource.data=this.devices
    }
  }

}
